/** Pure title-menu composition (unit tested without Phaser). */
import type { MenuItem } from '../MenuList';

export interface TitleEntry { label: string; run: () => void }

export const CONTINUE_LABEL = '继续旅程';
export const SETTINGS_LABEL = '设置';

/**
 * Builds the ordered menu items: the integrator's entries in the given order (with a chapter-beat
 * hint on 继续旅程) followed by 设置 when a settings opener exists.
 */
export function buildTitleItems(entries: TitleEntry[], opts: { continueHint?: string; settings?: () => void; settingsLabel?: string } = {}): MenuItem[] {
  const items: MenuItem[] = entries.map((e) => {
    const item: MenuItem = { label: e.label, onSelect: e.run };
    if (opts.continueHint && e.label === CONTINUE_LABEL) item.hint = opts.continueHint;
    return item;
  });
  if (opts.settings) items.push({ label: opts.settingsLabel ?? SETTINGS_LABEL, onSelect: opts.settings });
  return items;
}
